import { styled, css } from 'styled-components';

import { Media } from '@/js/libs/ui';
import { Badge, NotificationIndicator } from '@/js/libs/ui/src/V2';
import { COLLAPSING_TRANSITION, SPACER_DEFAULT } from '@/js/libs/ui/src/V2/Components/PuzzleNav/constants';
import { BUTTON_SIZE_DEFAULT_PX } from '@/js/libs/ui/src/V2/Controls/Button/constants';

import { MOBILE_HEADER_HEIGHT } from 'src/constants.tsx';

const SPACER_DEFAULT_HALF = `calc(${SPACER_DEFAULT} / 2)`;

export const Wrapper = styled.div<{ $isCollapsedNav: boolean; $isCompanySwitchView: boolean }>`
  position: sticky;
  z-index: 11;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media ${Media.lgMin} {
    ${({ $isCollapsedNav, $isCompanySwitchView }) => css`
      padding: ${SPACER_DEFAULT} ${$isCollapsedNav ? SPACER_DEFAULT : `calc(${SPACER_DEFAULT} - 4px)`}
        ${!$isCollapsedNav && $isCompanySwitchView ? SPACER_DEFAULT_HALF : SPACER_DEFAULT}
        ${$isCollapsedNav ? SPACER_DEFAULT : `calc(${SPACER_DEFAULT} + 6px)`};
      flex-direction: ${$isCollapsedNav && 'column'};
      gap: ${$isCollapsedNav && SPACER_DEFAULT_HALF};
    `}
  }
  @media ${Media.mdMax} {
    background-color: ${({ theme }) => theme.colors.grey00_1};
    padding: 0 ${SPACER_DEFAULT};
    height: ${MOBILE_HEADER_HEIGHT}px;
    align-items: center;
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      transition: left ${COLLAPSING_TRANSITION};
      height: 1px;
      background-color: ${({ theme }) => theme.colors.grey10_1};
    }
  }
`;

export const ToggleButtonWrapper = styled.div<{ $isCollapsedNav?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${BUTTON_SIZE_DEFAULT_PX};
  width: ${({ $isCollapsedNav }) => $isCollapsedNav && '100%'};
  gap: ${SPACER_DEFAULT_HALF};
  position: relative;

  @media ${Media.lgMin} {
    ${({ $isCollapsedNav }) => css`
      margin-bottom: ${$isCollapsedNav ? SPACER_DEFAULT_HALF : 'none'};
    `}
  }
`;

export const ToggleButton = styled.button.attrs({
  type: 'button',
})<{ $isCollapsedNav?: boolean }>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  outline: none;
  ${({ $isCollapsedNav }) =>
    $isCollapsedNav &&
    css`
      @media ${Media.lgMin} {
        position: relative;
        height: 100%;
        width: 100%;
        & > * {
          transition: opacity ${COLLAPSING_TRANSITION};
          position: absolute;
          margin: auto;

          &:first-child {
            opacity: 0;
          }

          &:last-child {
            opacity: 1;
          }
        }
        &:hover > * {
          &:first-child {
            opacity: 1;
          }

          &:last-child {
            opacity: 0;
          }
        }
      }
    `}
`;

export const MailIconWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const MailIconIndicator = styled(NotificationIndicator)`
  position: absolute;
  top: 0;
  right: 0;
`;

export const LogoMenuGroup = styled.div`
  display: flex;
  gap: ${SPACER_DEFAULT_HALF};
  align-items: center;
  a {
    line-height: 1;
  }
`;

export const DevBadge = styled(Badge)<{ $isCollapsedNav: boolean }>`
  position: absolute;
  @media ${Media.lgMin} {
    left: calc(100% - ${({ $isCollapsedNav }) => ($isCollapsedNav ? 18 : 8)}px);
    bottom: calc(100% - ${({ $isCollapsedNav }) => ($isCollapsedNav ? 6 : 10)}px);
  }
  @media ${Media.mdMax} {
    left: calc(100% - 8px);
    bottom: calc(100% - 10px);
  }
  text-transform: uppercase;
`;
